import gql from 'graphql-tag'

export const getExpiringPolicyNumber = gql`
  query getExpiringPolicyNumber($month: Int!, $year: Int!){
    getExpiringPolicyNumber(month: $month, year: $year){
      date
      expiringNumberInThisDay
      expiringNumberInAMonth
      bindingNumberInThisDay
      effectiveNumberInThisDay
      totalPremiumOfBindingInThisDay
      totalCommissionOfBindingInThisDay
    }
  }
`

export const getExpiringPolicies = gql`
  query getExpiringPolicies($expirationEndDate: String!, $expirationStartDate: String!) {
    getExpiringPolicies(expirationEndDate: $expirationEndDate, expirationStartDate: $expirationStartDate) {
        id
        policyName
        policyNumber
        status
        carrier {
          name
        }
        premium
        effectiveDate
        expirationDate
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        writingAgents {
          id
          username
        }
    }
  }
`

export const getBindingPolicies = gql`
  query getBindingPolicies($bindEndDate: String!, $bindStartDate: String!) {
    getBindingPolicies(bindEndDate: $bindEndDate, bindStartDate: $bindStartDate) {
        id
        policyName
        policyNumber
        status
        carrier {
          name
        }
        premium
        effectiveDate
        expirationDate
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        writingAgents {
          id
          username
        }
    }
  }
`

export const getEffectivePolicies = gql`
  query getEffectivePolicies($effectiveEndDate: String!, $effectiveStartDate: String!) {
    getEffectivePolicies(effectiveEndDate: $effectiveEndDate, effectiveStartDate: $effectiveStartDate) {
        id
        policyName
        policyNumber
        status
        carrier {
          name
        }
        premium
        effectiveDate
        expirationDate
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        writingAgents {
          id
          username
        }
    }
  }
`
